import moment from "moment";

import { Card, Box, Typography } from "@mui/material";

const Comment = ({ content, displayName, photoURL, createdAt }) => {
  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          ml: "auto",
          mb: 2,
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Card
            elevation={0}
            sx={{
              px: 2,
              py: 2,
            }}
          >
            <Box sx={{ mb: 1 }}>
              <Typography sx={{ fontWeight: "600", mb: 3 }}>
                {displayName}
              </Typography>
            </Box>

            <Typography color="inherit" variant="body1">
              {content}
            </Typography>
          </Card>
          <Box
            sx={{
              display: "flex",

              mt: 1,
              px: 2,
            }}
          >
            <Typography color="textSecondary" noWrap variant="caption">
              {/* {moment(dateTime).calendar()} */}
              {moment(dateTime).calendar()}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Comment;
